
export type DatabaseAccess =
    "ReadWrite"
    | "Admin"
    | "Read";